import { render, staticRenderFns } from "./urgentActions.vue?vue&type=template&id=18612f89&"
import script from "./urgentActions.vue?vue&type=script&lang=js&"
export * from "./urgentActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports